import React from 'react'

export default class NewAufgabeIcon extends React.Component {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
        <g fill="#FCE531" fillRule="evenodd">
          <path d="M16.45 12l-.001 3.55H20v.9h-3.551L16.45 20h-.9l-.001-3.551L12 16.45v-.9l3.549-.001L15.55 12h.9z" />
          <path fillRule="nonzero" d="M6.05 6.5h9.9v1h-9.9z" />
          <path fillRule="nonzero" d="M20 2v8.099h-1.35V3.35H3.35v15.3H10V20H2V2h18z" />
        </g>
      </svg>
    )
  }
}
